import React, {useEffect, useState} from 'react';
import {useQuery} from "@apollo/client";
import {TrackingTableTitle} from "../../../../enums/DeliveryTrackingTableEnum";
import {OrderBaseItem} from "../../../delivery/task/components/TrackingTablePage";
import {
    DspDeliveryTaskOrderListResponse,
    GET_DSP_DELIVERY_TASK_ORDER_LIST
} from "../../graphql/queries/dspDeliveryTaskOrderList";
import MulticolumnTrackingTablePage from "../../../delivery/components/MulticolumnTrackingTablePage";
import {compareDeliveryTaskOrders, formatStopNumber} from "../../../../utils/stopNumberUtils";
import {t} from "../../../../i18n";
import useDspWarehouseStore from "../../store/dspWarehouseStore";

interface ArrivalScanDetailsProps {
}

const ReceivingSortingDetailsPage: React.FC<ArrivalScanDetailsProps> = () => {
    const [arrivalScanData,setArrivalScanData] = useState<OrderBaseItem[]>([]);
    const selectedWarehouseId = useDspWarehouseStore((state) => state.selectedWarehouseId);
    const { data } = useQuery<DspDeliveryTaskOrderListResponse>(GET_DSP_DELIVERY_TASK_ORDER_LIST, {
        variables: { warehouseId: selectedWarehouseId ? parseInt(selectedWarehouseId) : undefined },
    });
    const dspDeliveryTasks = data?.getDeliveryTaskOrderListByDspId || [];
    useEffect(() => {
        if (!dspDeliveryTasks.length) return;
        const formattedData = [...dspDeliveryTasks]
            .sort((a, b) => {
                return compareDeliveryTaskOrders(a, b);
            })
            .map(item => ({
                trackingNumber: item.trackingNumber,
                stop: formatStopNumber(item.stopNumber,item.subStopNumber),
                value: item.routeName,
            }));
        setArrivalScanData(formattedData);
    }, [data]);

    return (
        <MulticolumnTrackingTablePage
            title={TrackingTableTitle.ARRIVAL_SCAN_DETAILS}
            data={arrivalScanData}
            tableRows={[
                t('pages.dsp.home.receivingSorting.trackingNo') as string,
                t('pages.dsp.home.receivingSorting.stop') as string,
                t('pages.dsp.home.receivingSorting.route') as string
            ] as String[]}
        />
    );
};

export default ReceivingSortingDetailsPage;
